export default __webpack_public_path__ + "static/media/standsExpo_airis.38b36c0b.jpg";